import React from "react";
import MangeDashboard from "./MangeDashboard";
import Ehraz from "./Ehraz";


export default function EhrazReject({message = ''}) {

    return(


        <MangeDashboard>


                    <div className="verification section-padding">
            <div className="container h-100">
                <div className="row justify-content-center h-100 align-items-center">
                    <div className="col-xl-5 col-md-6">
                        <div className="auth-form card">
                            <div className="card-body">
                                <form className="identity-upload">
                                    <div className="identity-content">
                                        <img src="https://img.icons8.com/glyph-neue/64/fa314a/cancel.png"/>
                                        <br/>
                                        <hr/>
                                        <h6> هویت شما تایید نشد </h6>
                                        <p className={'text-large'}>{message}</p>
                                    </div>

                                    <div className="text-center mb-4">
                                        <a href={'/ehrazz'} className="btn btn-success pl-5 pr-5 text-white">احراز هویت مجدد</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        </MangeDashboard>

    )

}